import { FilterRequirementsAutocomplete } from '../baseInputTypes/FilterRequirementsAutocomplete'

export const Categories = () => (
  <FilterRequirementsAutocomplete
    label="Categories"
    fieldName={'categories'}
    fieldPath={'documentInformation.categories'}
  />
)
